import React from "react";
import NavBar from "./NavBar";
import ProfileDetails from "./ProfileDetails";
import ProfileImages from "./ProfileImages";

const Profile = () => {
  return (
    <div>
      <NavBar />
      <ProfileDetails />
      <ProfileImages />
    </div>
  );
};

export default Profile;
